const infContain = document.querySelector('product-info');
const sizeLength = document.querySelector('.sampleSelectDropdown').length;
var priceContain = document.querySelector('#MainContent');
var variantHasBeenSelected = false;

async function getFirstVariant() {
    if (window.location.href.indexOf("variant=") > -1 || !sizeLength || sizeLength <= 1) {
        priceContain.classList.add('show-price');
        return;
    }
    for (let i = 0; i < sizeLength; i++) {
        if (document.querySelector('.sampleSelectDropdown').getElementsByTagName('option')[i].getAttribute('data-is-available') == "true" && i > 0) {
            document.querySelector('.sampleSelectDropdown').getElementsByTagName('option')[i].selected = 'selected';
            document.querySelector('variant-selects').dispatchEvent(new Event('change'));
            variantHasBeenSelected = true;
            break;
        }
        else {
            continue;
        }
    }

    if (variantHasBeenSelected == false) {
        document.querySelector('#tryASample').classList.add('hidden');
    }
}

getFirstVariant();

infContain.addEventListener("click", function (e) {
    if (e.target.classList.contains('tryasample')) {
        document.querySelector('.sampleSelectDropdown').getElementsByTagName('option')[0].selected = 'selected';
        document.querySelector('variant-selects').dispatchEvent(new Event('change'));
    }
}); 